module.exports = "pegasus_template/assets/header.png";